import React, {useState, useEffect, useContext} from "react";
import CongratPopup from "../Assets/CongratPopup.png";
import { signOut } from "firebase/auth";
import { useDispatch, useSelector } from "react-redux";
import { auth, provider } from "../../../LoginAndRegister/Components/UserSigning/Components/LeftSide/ContinueWIth/config";
import { SocketContext } from "../../../../App";
import { GetLocalStorage } from "../../../../Helpers/LocalStorage/LocalStorage";
import { LogOut } from "../../../../Actions/UserA";

const ResetPasswordSettingsSuccessPopup = ({setPasswordResetSuccessShowPopup, isLandingPage }) => {
  const Dispatch = useDispatch();
  const socket = useContext(SocketContext);

  const UserId = GetLocalStorage("UserInfo")?.UserId;
  console.log("UserId in SchoolTimingsAndSchedule is:",UserId);

  const closePopup = () =>{
      console.log("Close icon clicked");
      setPasswordResetSuccessShowPopup(false);
  }

  const LogOutUser = async () => {
    signOut(auth, provider)
        .then(() => {
            console.log("Sign-out successful.");
            socket?.emit("offline", { UserId: UserId });

            // Dispatch logout action
            Dispatch(LogOut());

            // Determine the base URL
            // const baseURL =
            //     window.location.hostname === "localhost"
            //         ? "http://localhost:3000"
            //         : "https://vehiclelearning.com/";

            // // Redirect only if the user is not already on the target page
            // if (window.location.href !== baseURL) {
            //     setTimeout(() => {
            //         window.location.href = baseURL;
            //     }, 3000);
            // }

            // Dynamically determine the base URL
            let baseURL = "";
            if (window.location.hostname === "localhost") {
                baseURL = "http://localhost:3000";
            } else {
                // Always redirect to the same host (whether vehiclelearning.com or prod.vehiclelearning.com)
                baseURL = `${window.location.protocol}//${window.location.hostname}`;
            }

            // Redirect only if the user is not already on the target page
            if (window.location.href !== baseURL + "/") {
                setTimeout(() => {
                    window.location.href = baseURL + "/";
                }, 3000);
            }
            
        })
        .catch((error) => {
            console.error("Error during sign-out:", error);
        });
  };

    return (
      <div className="fixed inset-0 z-[99] flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-md transition duration-500">
        <div className="relative rounded-[9px] bg-[linear-gradient(270deg,_#D7D9FF_0%,_#FFFFFF_100%)] px-[30px] pb-[30px] shadow-lg">
        {/* <div className="absolute top-2 right-2">
              <img
                className="absolute right-1 top-[4px] cursor-pointer"
                src={require("../Assets/Cross.svg").default}
                alt=""
                onClick={closePopup}
              />
            </div> */}

            <div  className="mt-[-120px] flex w-full justify-center items-center">
              <img
                src={CongratPopup}
                alt="img"
              />
            </div>

          <h2
            className=" mb-4 text-center text-[16px] mt-[10px]"
          >
            Congratulations !!
          </h2>
          <p className="text-center text-[14px] w-[270px]">You have successfully reset your password.</p>

          <div className="w-full flex flex-col ustify-center items-center gap-[15px] mt-[30px]">
            {/* <button
                className="px-[15px] py-[7px] w-[90%] rounded-[6px] bg-[#A1A3EF] text-[#FFFFFF] text-[14px] cursor-pointer"
                style={{border:"2px solid #A1A3EF"}}
                onClick={LogOutUser}>
                Sign Out
            </button> */}

             {isLandingPage ? (
              <button
                  className="px-[15px] py-[7px] w-[90%] rounded-[6px] bg-[#A1A3EF] text-[#FFFFFF] text-[14px] cursor-pointer"
                  style={{border:"2px solid #A1A3EF"}}
                  onClick={closePopup}>
                  Back
              </button>
            ) : (
              <button
                  className="px-[15px] py-[7px] w-[90%] rounded-[6px] bg-[#A1A3EF] text-[#FFFFFF] text-[14px] cursor-pointer"
                  style={{border:"2px solid #A1A3EF"}}
                  onClick={LogOutUser}>
                  Sign Out
              </button>
            )}

            {/* <p className="text-[14px] text-center cursor-pointer" onClick={closePopup}>Back</p> */}
          </div>

        </div>
      </div>
    );
  };

export default ResetPasswordSettingsSuccessPopup;
